import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
import t from '@jetshop/intl';
import Image from '@jetshop/ui/Image/Image';
import React from 'react';
import styled from 'react-emotion';
import MaxWidth from '../Layout/MaxWidth';
import striptags from 'striptags';

export const CategoryHeaderWrapper = styled(MaxWidth)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 100%;
  width: 100%;
  padding: 0px !important;

  p {
    font-size: 13px;
    max-width: 540px;
    line-height: 18px;
    font-size: 15px;
    margin-top: 10px;
  }

  a {
    font-weight: bold;
    color: black;
    text-decoration: none;
  }
`;

const CategoryImageWrapper = styled('div')`
  height: 320px;
  width: 100%;
  display: flex;

  // ::after {
  //   display: block;
  //   position: relative;
  //   background-image: linear-gradient(
  //     0deg,
  //     rgba(0, 0, 0, 0.195) 0%,
  //     rgba(0, 0, 0, 0) 100%
  //   );
  //   width: 100%;
  //   content: '';
  //   margin-top: -320px;
  //   height: 320px;
  // }

  div {
    background-color: ${({ theme }) => theme.colors.background};
  }

  ${({ theme }) => theme.below.md} {
    height: 217px;
    ::after {
      margin-top: -217px;
      height: 217px;
    }
  }
`;

export const NoImageWrapper = styled('div')`
  margin-top: 3.5rem;
  padding: 10px;
  ${({ theme }) => theme.below.md} {
    margin-top: 0;
    padding: 0 10px;
  }
`;

export const CategoryName = styled('h1')`
  line-height: normal;
  font-size: 25px;
  margin-bottom: 10px;
  font-weight: bold;
  text-transform: uppercase;
  ${({ theme }) => theme.below.md} {
    margin-bottom: 0;
  }
`;

export const CategoryContent = styled('div')``;

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  width: 100%;
  max-width: 80rem;
  padding: 1.2rem 2rem;
  margin: 0;
  li {
    color: #000;
    font-size: 13px;
    font-weight: normal;
    a {
      color: #000;
      text-decoration: none;
      font-size: 13px;
      font-weight: normal;
    }
  }
`;

const HeaderImage = styled(Image)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  ${StyledBreadcrumbs} {
    a,
    li {
      color: white;
    }
  }
`;

export const Inner = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const NewContent = ({ category }) => (
  <Inner>
    {category?.mainHeader ? (
      <CategoryName data-testid="page-header">
        {category.mainHeader}
      </CategoryName>
    ) : (
      <CategoryName data-testid="page-header">{category.name}</CategoryName>
    )}
  </Inner>
);

const CategoryHeader = ({ category, parents, firstParagraph }) => {
  const breadcrumbProps = {
    breadcrumbText: category.breadcrumbText,
    parents,
  };
  const isImageBackground = category.images && category.images.length > 0;
  const cleanFirstParagraph = striptags(firstParagraph, [], '\r');

  const handleClick = () => {
    document
      .getElementById('full-category-content')
      .scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  return (
    <CategoryHeaderWrapper>
      <StyledBreadcrumbs {...breadcrumbProps} />
      {isImageBackground ? (
        <CategoryImageWrapper>
          <HeaderImage
            src={category.images}
            fillAvailableSpace
            cover
            quality={80}
          ></HeaderImage>

          <Inner>
            {category?.mainHeader ? (
              <CategoryName data-testid="page-header">
                {category.mainHeader}
              </CategoryName>
            ) : (
              <CategoryName data-testid="page-header">
                {category.name}
              </CategoryName>
            )}

            {cleanFirstParagraph ? (
              <p onClick={() => handleClick()}>
                {cleanFirstParagraph.split(' ').slice(0, 25).join(' ')}
                {'... '}
                <u>{t('Read more')}</u>
              </p>
            ) : null}
          </Inner>
        </CategoryImageWrapper>
      ) : (
        <NoImageWrapper>
          <NewContent category={category} breadcrumbProps={breadcrumbProps} />
          {cleanFirstParagraph ? (
            <p onClick={() => handleClick()}>
              {cleanFirstParagraph.split(' ').slice(0, 25).join(' ')}
              {'... '}
              <u>{t('Read more')}</u>
            </p>
          ) : null}
        </NoImageWrapper>
      )}
    </CategoryHeaderWrapper>
  );
};

export default CategoryHeader;
